export const LOANBOOK_INVOICE = '/pdf/loanbook-invoice';
export const LOANBOOK_INVOICE_DETAILS = '/generateXlsx/loanbook-invoice-details';
export const COMMISSION_QUERY = '/commission-queries';
